import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { createForm, getFormBySlug } from "../../apis/forms";
import { RENDER_FORMS_URL_PREFIX } from "../../constants/forms.constants";
import { createFormsSurveyCreator } from "../../utils/forms.functions";
import DesignerLayout from "../shared/DesignerLayout";
var FormsDesigner = function () {
    var config = useMemo(function () { return ({
        listPath: "/forms/list",
        urlPrefix: RENDER_FORMS_URL_PREFIX,
        createApi: createForm,
        fetchApi: getFormBySlug,
        createCreator: createFormsSurveyCreator,
        defaultAuthRequired: true,
    }); }, []);
    return _jsx(DesignerLayout, { config: config });
};
export default FormsDesigner;
